import { Component, OnInit } from '@angular/core';
import { ExportService } from './export-overlay.service';
import { ExportTaskComponent } from './tasks/component/export-task.component';
import { LegacyExportTask } from './tasks/core/export-task-legacy';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ExportTask } from './tasks/core/export-task';

@Component({
  selector: 'app-export-overlay',
  templateUrl: './export-overlay.component.html',
  styleUrl: './export-overlay.component.scss',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    ExportTaskComponent,
  ],
})
export class ExportOverlayComponent implements OnInit {
  tasks: Array<LegacyExportTask | ExportTask> = [];

  constructor(
    public exportService: ExportService,
  ) {}

  ngOnInit(): void {
    this.tasks = this.exportService.getTasks();
    this.exportService.change$.subscribe(() => {
      this.tasks = this.exportService.getTasks();
    });
  }

  onHideButtonPressed() {
    this.exportService.toggleVisibility();
  }
}
